module.exports = __webpack_public_path__ + "static/media/rider.223db1ca.png";